var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticClass:"full-sidebar",attrs:{"id":"materialpro"}},[_c('router-view'),_c('base-alerts'),_c('base-loading')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }